require('../../schedule/scheduleGame/scheduleGameController.js');

"use strict";

angular.module('app.shared.gameInfo.gameInfoDirective', ['app.schedule.scheduleGame.scheduleGameController'])
    .directive('gameInfo', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/shared/gameInfo/gameInfoView.html',
                controller: 'app.schedule.scheduleGame.scheduleGameController',
                scope: {
                    game: '=?'
                }
            }
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/gameInfo/gameInfoDirective.js